const HIDE_TOAST_DELAY = 8000;
const HIDE_TOAST_SCROLL = 3;

/**
 * 딜 상세 하단에 노출될 Toast Popup 입니다.
 */
export default class CommonToast {
  constructor() {
    this.nScrollCount = 0;
    this.bHideToast = false;
    this.welCommonToast = $('.toast_common_popup');
  }

  update(sStorageKey) {
    if (sStorageKey === 'commonToast') {
      this.addToast();
    }
  }

  showToast(msg = '') {
    this.welCommonToast.append(msg);
    this.welCommonToast.fadeIn();

    setTimeout(() => this.hideToast(), HIDE_TOAST_DELAY);
    this.bHideToast = false;
  }

  hideToast() {
    if (!this.bHideToast) {
      this.welCommonToast.fadeOut('slow', () => this.welCommonToast.empty());
    }

    this.bHideToast = true;
  }

  onScroll = () => {
    this.nScrollCount += 1;

    if (this.nScrollCount > HIDE_TOAST_SCROLL) {
      this.hideToast();
    }
  };
}
